
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("krs8y", function(module, exports) {

$parcel$export(module.exports, "NotificationsContentLoader", () => $d8b987b37f05e4bd$export$bae4076b81272f49);
$parcel$export(module.exports, "NotificationsComponent", () => $d8b987b37f05e4bd$export$277811c2f9b18413);

var $gwFzn = parcelRequire("gwFzn");

var $4y1GY = parcelRequire("4y1GY");

var $4jR19 = parcelRequire("4jR19");

var $diswb = parcelRequire("diswb");

var $axAnW = parcelRequire("axAnW");

var $Asv1P = parcelRequire("Asv1P");

var $lGgRw = parcelRequire("lGgRw");

var $9Zu7R = parcelRequire("9Zu7R");

var $c3uZU = parcelRequire("c3uZU");

var $jUWCg = parcelRequire("jUWCg");

var $6cnUO = parcelRequire("6cnUO");
var $5izcQ = parcelRequire("5izcQ");
var $2Fndw = parcelRequire("2Fndw");

var $inPa6 = parcelRequire("inPa6");

var $lwNi3 = parcelRequire("lwNi3");

var $ljm2R = parcelRequire("ljm2R");

var $dEBDF = parcelRequire("dEBDF");

var $bQm3c = parcelRequire("bQm3c");

var $dPJCf = parcelRequire("dPJCf");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $3RJyD = parcelRequire("3RJyD");

var $8m7DH = parcelRequire("8m7DH");

var $djivE = parcelRequire("djivE");
const $d8b987b37f05e4bd$var$fabricNotificationLogUrl = '/gateway/api/notification-log';
const $d8b987b37f05e4bd$var$REFRESH_INTERVAL = 60000;
const $d8b987b37f05e4bd$var$CLEAR_BADGE_TIME = 10000;

const $d8b987b37f05e4bd$export$bae4076b81272f49 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZL8ot",
    name: "NotificationsContentLoader",
    loader: async ()=>(await (parcelRequire("lCwWH"))).NotificationsContent
});
class $d8b987b37f05e4bd$var$EmptyNotificationLogClient extends (0, $c3uZU.NotificationLogClient) {
    countUnseenNotifications() {
        return Promise.resolve({
            count: 0
        });
    }
    constructor(){
        super('', '');
    }
}
const $d8b987b37f05e4bd$export$277811c2f9b18413 = /*#__PURE__*/ (0, $gwFzn.memo)(()=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [showNotificationSpotlight, setShowNotificationSpotlight] = (0, $gwFzn.useState)(true);
    const [isCleared, setIsCleared] = (0, $gwFzn.useState)(false);
    const [unreadCount, setUnreadCount] = (0, $gwFzn.useState)('');
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    const { isSiteAdmin: isSiteAdmin, hasSpotlightBeenShown: hasSpotlightBeenShown } = (0, $8m7DH.useRequestNotificationSpotlight)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const location = (0, $4y1GY.useLocation)();
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $djivE.AppNavigationUnifiedQuery), {
        skip: !isLicensed
    });
    if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const shouldShowSpotlight = isSiteAdmin && !hasSpotlightBeenShown;
    (0, $gwFzn.useEffect)(()=>{
        if (isCleared) {
            const timeout = setTimeout(()=>{
                setIsCleared(false);
            }, $d8b987b37f05e4bd$var$CLEAR_BADGE_TIME);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        isCleared
    ]);
    const onClick = (0, $Asv1P.useCallbackWithAnalytics)(()=>{
        if (isOpen) {
            onClose();
            performance.clearMarks('notification.list.render.start');
        } else {
            performance.mark('notification.list.render.start');
            setIsCleared(true);
            setIsOpen(true);
        }
    }, {
        type: 'sendUIEvent',
        data: {
            source: 'globalNavigation',
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'notifications',
            attributes: {
                selectedItemPageContext: routeDataRef.current?.routeName,
                navigationLayer: 'global',
                navVersion: '3',
                navdexPointType: (0, $dEBDF.START_TOUCH)
            }
        }
    });
    const onMouseOverOnBell = ()=>{
        $d8b987b37f05e4bd$export$bae4076b81272f49.preload();
    };
    const focusNotificationBtn = ()=>{
        const notificationBtn = document.querySelector("[data-testid='app-navigation-notifications-button'] button");
        notificationBtn.focus();
    };
    const onClose = (0, $gwFzn.useCallback)(()=>{
        setIsOpen(false);
        focusNotificationBtn();
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (isOpen && location) // on any location change close notification drawer
        onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onClose,
        location
    ]);
    const notificationLogClient = (0, $gwFzn.useMemo)(()=>new (0, $c3uZU.NotificationLogClient)($d8b987b37f05e4bd$var$fabricNotificationLogUrl, undefined), []);
    const formatUnreadCount = (count)=>{
        if (count > 9) return ' (9+)';
        if (count > 0) return ` (${count})`;
        return '';
    };
    (0, $gwFzn.useEffect)(()=>{
        notificationLogClient.countUnseenNotifications().then((res)=>{
            setUnreadCount(formatUnreadCount(res.count));
            if (res.count >= 9) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'unseenNotificationsOver9'
                }
            }).fire();
        }).catch(()=>{});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireNotificationSpotlightCtaClickedEvent = (0, $gwFzn.useCallback)((buttonType)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'requestSpotlightButton',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'requestSpotlightButton',
                attributes: {
                    buttonType: buttonType
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const NotificationsBadge = (0, $gwFzn.useMemo)(()=>()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Zu7R.NotificationIndicator), {
                onCountUpdated: (count)=>{
                    setUnreadCount(formatUnreadCount(count.newCount));
                },
                notificationLogProvider: Promise.resolve(isCleared || isOpen ? new $d8b987b37f05e4bd$var$EmptyNotificationLogClient() : notificationLogClient),
                refreshRate: $d8b987b37f05e4bd$var$REFRESH_INTERVAL
            });
        }, [
        isOpen,
        isCleared,
        notificationLogClient
    ]);
    const renderNotificationsIcon = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jUWCg.Notifications), {
            badge: NotificationsBadge,
            onClick: onClick,
            onMouseEnter: onMouseOverOnBell,
            isSelected: isOpen,
            tooltip: isLiveEditMode || isOnEditRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                id: "app-navigation.notifications.link",
                defaultMessage: "Notifications{unreadCount}",
                values: {
                    unreadCount: unreadCount
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                shortcut: (0, $ljm2R.UNIVERSAL_NOTIFICATIONS_SHORTCUT),
                contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                    id: "app-navigation.notifications.link",
                    defaultMessage: "Notifications{unreadCount}",
                    values: {
                        unreadCount: unreadCount
                    }
                }),
                isTooltip: true
            }),
            ...triggerProps
        });
    if (loading || !isLicensed) return null;
    else {
        const user = data?.user;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            "data-testid": "app-navigation-notifications",
            "data-vc": "app-navigation-notifications",
            ...ssrPlaceholderIdProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
            placement: "bottom-end",
            shouldFlip: true,
            rootBoundary: "viewport",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d8b987b37f05e4bd$export$bae4076b81272f49, {
                    user: user
                }),
            isOpen: isOpen,
            onClose: onClose,
            shouldRenderToParent: true,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                    "data-testid": "app-navigation-notifications-button"
                }, shouldShowSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
                    name: "admin-request-spotlight"
                }, renderNotificationsIcon(triggerProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Fndw.default), null, showNotificationSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $axAnW.default), {
                    client: coordinationClient,
                    messageId: (0, $3RJyD.SPOTLIGHT_MESSAGE_ID)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3RJyD.NotificationIconSpotlight), {
                    onClose: async ()=>{
                        setShowNotificationSpotlight(false);
                        fireNotificationSpotlightCtaClickedEvent('close');
                        await coordinationClient.stop((0, $3RJyD.SPOTLIGHT_MESSAGE_ID));
                    },
                    onViewRequests: async (e)=>{
                        e.stopPropagation();
                        setShowNotificationSpotlight(false);
                        setIsOpen(true);
                        fireNotificationSpotlightCtaClickedEvent('viewRequests');
                        await coordinationClient.stop((0, $3RJyD.SPOTLIGHT_MESSAGE_ID));
                    }
                })))) : renderNotificationsIcon(triggerProps))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
            deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.NOTIFICATIONS_SHORTCUT) : undefined,
            accelerator: (0, $ljm2R.UNIVERSAL_NOTIFICATIONS_SHORTCUT),
            listener: onClick,
            isAppNavigationShortcut: true
        }));
    }
});

});
parcelRegister("jUWCg", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $db2b40f06156720d$export$36ba2f559d49a8f6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3bb5K = parcelRequire("3bb5K");

var $hslOl = parcelRequire("hslOl");

var $8MTIk = parcelRequire("8MTIk");
const $db2b40f06156720d$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $db2b40f06156720d$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { badge: badge, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hslOl.BadgeContainer), {
        id: $db2b40f06156720d$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
            "aria-describedby": $db2b40f06156720d$var$NOTIFICATIONS_BADGE_ID,
            component: component,
            href: href,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3bb5K))), {
                spacing: "spacious",
                color: "currentColor",
                label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});
parcelRegister("3bb5K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01602fb49c3451f8884e2ed4b4e67e9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $250b00bee59854d3$var$_react = $250b00bee59854d3$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $250b00bee59854d3$var$_notification = $250b00bee59854d3$var$_interopRequireDefault((parcelRequire("ckcSY")));

var $250b00bee59854d3$var$_notification2 = $250b00bee59854d3$var$_interopRequireDefault((parcelRequire("jOLOx")));
function $250b00bee59854d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for NotificationIcon.
 * This component is NotificationIcon, with `UNSAFE_fallbackIcon` set to "NotificationIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $250b00bee59854d3$var$NotificationIcon = (props)=>/*#__PURE__*/ $250b00bee59854d3$var$_react.default.createElement($250b00bee59854d3$var$_notification.default, Object.assign({
        LEGACY_fallbackIcon: $250b00bee59854d3$var$_notification2.default
    }, props));
$250b00bee59854d3$var$NotificationIcon.Name = 'NotificationIconMigration';
var $250b00bee59854d3$var$_default = module.exports.default = $250b00bee59854d3$var$NotificationIcon;

});


parcelRegister("3RJyD", function(module, exports) {

$parcel$export(module.exports, "SPOTLIGHT_MESSAGE_ID", () => $70e7891a258e3bf6$export$d2ea4f931a71a509);
$parcel$export(module.exports, "NotificationIconSpotlight", () => $70e7891a258e3bf6$export$e8547abadc10dd6e);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $js7oX = parcelRequire("js7oX");

var $5RBJ9 = parcelRequire("5RBJ9");

var $inPa6 = parcelRequire("inPa6");

var $lwNi3 = parcelRequire("lwNi3");

var $8m7DH = parcelRequire("8m7DH");
const $70e7891a258e3bf6$export$d2ea4f931a71a509 = 'confluence-admin-request-spotlight';
const $70e7891a258e3bf6$export$269cdaea24f37ea6 = /*#__PURE__*/ (0, $gwFzn.memo)(({ onClose: onClose, onViewRequests: onViewRequests, intl: intl })=>{
    const { markSpotlightAsShown: markSpotlightAsShown } = (0, $8m7DH.useRequestNotificationSpotlight)();
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const messages = (0, $2nPZH.defineMessages)({
        spotlightNotificationText: {
            id: "app-navigation.cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text",
            defaultMessage: // eslint-disable-next-line no-restricted-syntax
            "When someone in your team requests a new product you'll get a notification here now."
        },
        spotlightCloseButtonText: {
            id: "app-navigation.cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-close-button-text",
            defaultMessage: "Close"
        },
        spotlightViewRequestsButtonText: {
            id: "app-navigation.cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-view-requests-button-text",
            defaultMessage: "View requests"
        }
    });
    // When the spotlight is viewed, mark as shown in local storage and stop the EP message
    (0, $gwFzn.useEffect)(()=>{
        markSpotlightAsShown();
        coordinationClient.stop($70e7891a258e3bf6$export$d2ea4f931a71a509);
    }, [
        markSpotlightAsShown,
        coordinationClient
    ]);
    const fireScreenEvent = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                action: 'viewed',
                name: 'requestSpotlightInlineDialog'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    // Fire analytics event when spotlight is viewed
    (0, $gwFzn.useEffect)(()=>{
        fireScreenEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5RBJ9.default), {
        target: "admin-request-spotlight",
        key: "admin-request-spotlight",
        targetRadius: 100,
        dialogPlacement: "bottom right",
        dialogWidth: 275,
        targetBgColor: "var(--ds-icon-inverse, #FFFFFF)",
        actions: [
            {
                onClick: (e)=>onViewRequests(e),
                text: intl.formatMessage(messages.spotlightViewRequestsButtonText)
            },
            {
                onClick: onClose,
                text: intl.formatMessage(messages.spotlightCloseButtonText),
                appearance: 'subtle'
            }
        ]
    }, intl.formatMessage(messages.spotlightNotificationText));
});
const $70e7891a258e3bf6$export$e8547abadc10dd6e = (0, $js7oX.default)($70e7891a258e3bf6$export$269cdaea24f37ea6);

});
parcelRegister("8m7DH", function(module, exports) {

$parcel$export(module.exports, "useRequestNotificationSpotlight", () => $e369e230c411dfc1$export$fc67e45e56a8c796);
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $diswb = parcelRequire("diswb");

var $gwFzn = parcelRequire("gwFzn");

var $d2LG0 = parcelRequire("d2LG0");

var $bQm3c = parcelRequire("bQm3c");

var $w033M = parcelRequire("w033M");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $e369e230c411dfc1$export$7f7daa8dea90d2b2 = // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Preloaded GraphQL Operation
(0, $d2LG0.default)`query UserPrivilegeQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole}`;
const $e369e230c411dfc1$export$fc67e45e56a8c796 = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { data: privilegeData } = (0, $diswb.useQuery)($e369e230c411dfc1$export$7f7daa8dea90d2b2, {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        skip: Boolean(undefined) // This query isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    });
    const [isSiteAdmin, setIsSiteAdmin] = (0, $gwFzn.useState)(false);
    const [hasSpotlightBeenShown, setHasSpotlightBeenShown] = (0, $gwFzn.useState)(true);
    const spotlightLocalStorageKey = `${(0, $1UApO.keys).NOTIFICATION_SPOTLIGHT_VIEWED}_${cloudId}_${userId}`;
    const markSpotlightAsShown = (0, $gwFzn.useCallback)(()=>{
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).NOTIFICATION_SPOTLIGHT_VIEWED, true);
        setHasSpotlightBeenShown(true);
    }, [
        setHasSpotlightBeenShown
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setIsSiteAdmin((0, $w033M.getIsSiteAdminFromQuery)(privilegeData));
    }, [
        privilegeData
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setHasSpotlightBeenShown((0, $e9zUf.confluenceLocalStorageInstance).getItemAsBoolean(spotlightLocalStorageKey));
    }, [
        spotlightLocalStorageKey
    ]);
    return {
        isSiteAdmin: isSiteAdmin,
        hasSpotlightBeenShown: hasSpotlightBeenShown,
        markSpotlightAsShown: markSpotlightAsShown
    };
};

});


parcelRegister("lCwWH", function(module, exports) {

let $fbd6b3ea60c14f5d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fbd6b3ea60c14f5d$var$load("iAaum"),
    $fbd6b3ea60c14f5d$var$load("1m9tW"),
    $fbd6b3ea60c14f5d$var$load("7J7Dl"),
    $fbd6b3ea60c14f5d$var$load("jqXtk"),
    $fbd6b3ea60c14f5d$var$load("6vzdH"),
    $fbd6b3ea60c14f5d$var$load("feuOx"),
    $fbd6b3ea60c14f5d$var$load("aGZFn"),
    $fbd6b3ea60c14f5d$var$load("5aY5g"),
    $fbd6b3ea60c14f5d$var$load("lH77i"),
    $fbd6b3ea60c14f5d$var$load("1c10c"),
    $fbd6b3ea60c14f5d$var$load("65Xax"),
    $fbd6b3ea60c14f5d$var$load("9ZY0L"),
    $fbd6b3ea60c14f5d$var$load("ej4rO"),
    $fbd6b3ea60c14f5d$var$load("gCIfF"),
    $fbd6b3ea60c14f5d$var$load("6qah4"),
    $fbd6b3ea60c14f5d$var$load("hR2t0"),
    $fbd6b3ea60c14f5d$var$load("cixpG"),
    $fbd6b3ea60c14f5d$var$load("h4Nf7"),
    $fbd6b3ea60c14f5d$var$load("lfEn7"),
    $fbd6b3ea60c14f5d$var$load("kGIBm"),
    $fbd6b3ea60c14f5d$var$load("69J1q"),
    $fbd6b3ea60c14f5d$var$load("aYGIV"),
    $fbd6b3ea60c14f5d$var$load("iMlqd"),
    $fbd6b3ea60c14f5d$var$load("2BIkk"),
    $fbd6b3ea60c14f5d$var$load("lJxwk"),
    $fbd6b3ea60c14f5d$var$load("77Ha0"),
    $fbd6b3ea60c14f5d$var$load("iPz8n"),
    $fbd6b3ea60c14f5d$var$load("aZinD"),
    $fbd6b3ea60c14f5d$var$load("ffEVr"),
    $fbd6b3ea60c14f5d$var$load("g9CVe"),
    $fbd6b3ea60c14f5d$var$load("joJy8"),
    $fbd6b3ea60c14f5d$var$load("aHE9G"),
    $fbd6b3ea60c14f5d$var$load("jRHtw")
]).then(()=>parcelRequire('9Lz1A'));

});



//# sourceMappingURL=NotificationsComponent.137168ff.js.map
